import { PublicSettings } from '@/interfaces/publicSettings';

let defaultCurrency = 'USD';
let referenceCurrency = 'SSP';
let internalBankCode = '';
let bankSwiftCode = '';
let bankName = '';

export const initCurrencyConfig = (settings: PublicSettings) => {
  defaultCurrency = settings.bankInfo.defaultCurrency || 'USD';
  referenceCurrency = settings.allowedCurrencies.find(c => c !== defaultCurrency) || 'SSP';
  internalBankCode = settings.bankInfo.bankCode || '';
  bankSwiftCode = settings.bankInfo.bankSwiftCode || '';
  bankName = settings.bankInfo.bankName || '';
};

export const getDefaultCurrency = (): string => defaultCurrency;
export const getReferenceCurrency = (): string => referenceCurrency;
export const getInternalBankCode = (): string => internalBankCode;
export const getBankSwiftCode = (): string => bankSwiftCode;
export const getBankName = (): string => bankName;
